import PickEntity from '../utils/pick-entity/pick-entity.js'
import BudgetGrid from './budget-grid/budget-grid.js'
import PpFileReader from './pp-file-reader/pp-file-reader.js'

export default class PpWebApp {
  constructor () {
    console.log('PpWebApp constructor')
    this.htmlTemplate = `
      <wp-container class="as-full-height width-xxl">
        <wp-container>
          zenflow account: <input type="text" id="app-account-id" class="width-full"/>
        </wp-container>

        <wp-card>
          <header>
            <h2>Production Pulse</h2>
          </header>
          <section>
            <h3>Upload Budget File</h3>
            <wp-container class="as-row">
              <input type="file" id="file-input" />
              <button type="submit" id="read-file-button" class="button">Upload File</button>
            </wp-container>            
          </section>
        </wp-card>

        <wp-container id="entity-picker" class="width-full"></wp-container>

        <wp-container id="budget-grid-container" class="as-fill-space width-full"></wp-container>
      </wp-container>
    `

    this.mountedOn = null
    this.data = {
      budget: null,
      ledgerAccounts: null
    }
  }

  mount (element) {
    console.log('PpWebApp mount')
    element.innerHTML = this.htmlTemplate
    this.mountedOn = element

    document.body.classList.add('webpaint')

    this.render()
  }

  render () {
    console.log('PpWebApp render')
    if (!this.mountedOn) return

    addListeners(this)

    manageAppAccountId(this)

    this.budgetGrid = new BudgetGrid()
    this.budgetGrid.mount(this.mountedOn.querySelector('#budget-grid-container'))

    // this.mountedOn.querySelector('#read-file-button').addEventListener('click', onReadFileButtonClick)
  }
}

async function manageAppAccountId (instance) {
  console.log('manageAppAccountId')
  if (!instance.mountedOn) return

  instance.mountedOn.querySelector('#app-account-id').addEventListener('change', async (event) => {
    console.log('appAccountId changed', event.target.value)
    localStorage.setItem('appAccountId', event.target.value)

    await showEntityPicker(instance)
  })

  function initAppAccountId () {
    console.log('initAppAccountId')
    const defaultAppAccountId = '8aa0631b-fcce-49d8-bfa5-1a20899b9a6a'
    const browserAppAccountId = localStorage.getItem('appAccountId')
    const currentAppAccountId = browserAppAccountId || defaultAppAccountId
    localStorage.setItem('appAccountId', currentAppAccountId)
    console.log('initAppAccountId done', currentAppAccountId)
  }

  initAppAccountId()
  instance.mountedOn.querySelector('#app-account-id').value = localStorage.getItem('appAccountId')

  instance.entityPicker = new PickEntity()
  await showEntityPicker(instance)
}

async function showEntityPicker (instance) {
  console.log('showEntityPicker')
  if (!instance.mountedOn) return

  instance.appAccountId = localStorage.getItem('appAccountId')

  instance.entityPicker.mount(instance.mountedOn.querySelector('#entity-picker'))
  await instance.entityPicker.loadEntities(instance.appAccountId)
  instance.entityPicker.render()

  instance.entityPicker.mountedOn.addEventListener('pp:onEntitySelectionChange', (event) => {
    console.log('pp:onEntitySelectionChange', event)
    instance.accountingOrganisationId = event.detail.accountingOrganisationId
  })

  instance.entityPicker.mountedOn.addEventListener('pp:loadedLedgerAccountsAndFinancialStatement', (event) => {
    console.log('pp:loadedLedgerAccountsAndFinancialStatement', event)
    instance.data.ledgerAccounts = event.detail.ledgerAccounts
    instance.data.financialStatement = event.detail.financialStatement

    instance.budgetGrid.render({
      data: instance.data,
      accountingOrganisationId: instance.accountingOrganisationId
    })
  })
}

function addListeners (instance) {
  console.log('addListeners')
  if (!instance.mountedOn) return

  instance.mountedOn.querySelector('#read-file-button').addEventListener('click', (event) => onReadFileButtonClick(instance, event))
}

async function onReadFileButtonClick (instance, event) {
  console.log('onReadFileButtonClick...', event)
  // console.log('files', instance.mountedOn.querySelector('#file-input').files)
  // console.log('file', instance.mountedOn.querySelector('#file-input').files[0])

  const file = instance.mountedOn.querySelector('#file-input').files[0]
  console.log('file...', file)

  const ppfileReader = new PpFileReader()
  console.log('ppfileReader', ppfileReader)
  await ppfileReader.readFile(file)

  const budget = ppfileReader.readBudget(0)
  console.log('budget', budget)
  instance.data.budget = budget

  instance.budgetGrid.render({
    data: instance.data,
    accountingOrganisationId: instance.accountingOrganisationId
  })
}
